import { getChallengePaidPlans } from '@wix/challenges-web-library';
import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { isProgramHasOneTimePayment } from '../../../selectors/payment/oneTimePayment';

export default function isPlansOnly(
  challenge: Challenge,
  userPaidPlans: any[] = [],
) {
  const isOTPPresent = isProgramHasOneTimePayment(challenge);
  const challengePaidPlans = getChallengePaidPlans(challenge.id, userPaidPlans);
  const isPlansPresent = challengePaidPlans?.length;

  return !isOTPPresent && isPlansPresent;
}
